import { images } from '.';
 
const monthlyRental = [  
    {   
        id: 1, 
        image: images.rtmartNeihu, 
        title: '大全聯內湖店',
        content: '聯絡電話：0935-991-909',
        paragraphs: [
            '地址：台北市內湖區舊宗路1段188號',
            '月租聯絡電話：0935-991-909',
        ]
    },
    {   
        id: 2, 
        image: images.rtmartBitang, 
        title: '大全聯碧潭店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    
    {   
        id: 3, 
        image: images.rtmartGinping, 
        title: '大全聯景平店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市中和區景平路182號B2',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 4, 
        image: images.rtmartTuchen, 
        title: '大全聯土城店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 5, 
        image: images.rtmartChungShiao, 
        title: '大全聯忠孝店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 6, 
        image: images.rtmartChungLi, 
        title: '大全聯中壢店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 7, 
        image: images.rtmartTouFen, 
        title: '大全聯頭份店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 8, 
        image: images.rtmartNayai, 
        title: '大全聯湳雅店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 9, 
        image: images.rtmartBade, 
        title: '大全聯八德店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 10, 
        image: images.rtmartChungmin, 
        title: '大全聯忠明店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 11, 
        image: images.rtmartChaiyi, 
        title: '大全聯嘉義店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 12, 
        image: images.rtmartYuanLin, 
        title: '大全聯員林店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 13, 
        image: images.rtmartTainan, 
        title: '大全聯台南店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
    {   
        id: 14, 
        image: images.rtmartFonsang, 
        title: '大全聯鳳山店',
        content: '聯絡電話：0800-208-333',
        paragraphs: [
            '地址：新北市新店區環河路22號B1',
            '月租聯絡電話：0800-208-333',
        ]
    },
 
];

export default monthlyRental;